<template>
    <section class="mb-8">
      <nuxt-img
        class="px-6 m-auto lg:px-10 lg:w-full lg:mt-8"
        :width="imageWidth"
        :height="imageHeight"
        sizes="sm:400px md:768px lg:1024px xl:1024px"
        loading="lazy"
        format="webp"
        :alt="imageAlt"
        :src="imageSrc"
      ></nuxt-img>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    imageWidth: {
      type: Number,
      default: 1000
    },
    imageHeight: {
      type: Number,
      default: 660
    },
    imageAlt: {
      type: String,
      default: "social media results"
    },
    imageSrc: {
      type: String,
      default: "/assets/images/fb-results.jpg"
    }
  });
  
  defineBuilderComponent({
    friendlyName: "SimpleImage",
    canHaveChildren: false,
    inputs: [
      {
        name: "imageWidth",
        type: "number",
        defaultValue: 1000
      },
      {
        name: "imageHeight",
        type: "number",
        defaultValue: 660
      },
      {
        name: "imageAlt",
        type: "text",
        defaultValue: "social media results"
      },
      {
        name: "imageSrc",
        type: "file",
        allowedFileTypes: ["jpeg", "jpg", "png", "svg", "webp"],
        defaultValue: "/assets/images/fb-results.jpg"
      }
    ]
  });
  </script>